import * as tslib_1 from "tslib";
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from '../communicator/channel-communicator/channel-communicator.service';
import { RequestService } from '../request/request-onboarding.service';
import * as i0 from "@angular/core";
import * as i1 from "../abre-cuentas/abre-cuentas.service";
import * as i2 from "../request/request-onboarding.service";
import * as i3 from "../communicator/channel-communicator/channel-communicator.service";
/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
var ProductsService = /** @class */ (function () {
    /**
     * Constructor de la clase
     *
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los servicios
     *
     * *Initialize method for services*
     *
     * @param {CopyService}    copyService    Injectable copyService service.
     * @param {RequestService} requestService Injectable abreCuentasService service.
     */
    function ProductsService(abreCuentasService, requestService, channel) {
        this.abreCuentasService = abreCuentasService;
        this.requestService = requestService;
        this.channel = channel;
    }
    /**
     * Asigna el tipo del producto
     *
     * *Assigns product type*
     *
     * @param {IProductsModel} product
     * @returns {Promise}
     */
    ProductsService.prototype.assignProductType = function (product) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestService
                .assignProductType(product.product_type)
                .then(function (response) {
                console.log('AssignProductType: ', response);
                resolve('0');
            }, function (error) {
                console.log('error', error);
                reject('-1');
            });
        });
    };
    /**
     * Obtiene las ofertas de los acuerdos
     *
     * *Gets Agreements offers*
     *
     * @returns {Promise}
     */
    ProductsService.prototype.getAgreementsOffers = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var code = _this.channel.getChannelId() === '163' ? '001' : _this.abreCuentasService.getproductSelected().code;
            if (code === '201' || code === '203') {
                _this.requestService
                    .getAgreementsOffers()
                    .then(function (response) {
                    response.data.forEach(function (agreement) {
                        agreement.description = agreement.agreement_name + " - " + agreement.agreement_id;
                    });
                    _this.abreCuentasService.setAgreementList(response.data);
                    resolve(code);
                    return;
                }, function () {
                    reject('-1');
                });
                return;
            }
            resolve(code);
        });
    };
    /**
     * Obtiene las ofertas de los acuerdos de libranza
     *
     * *Gets Agreements offers*
     *
     * @returns {Promise}
     */
    ProductsService.prototype.getAgreementsOffersLoan = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        console.log('solicitamos convenios');
                        _this.requestService
                            .getAgreementsLoan()
                            .then(function (response) {
                            response.data.forEach(function (agreement) {
                                agreement.description = agreement.client_name;
                            });
                            _this.abreCuentasService.setAgreementList(response.data);
                            resolve('200');
                            return;
                        }, function () {
                            reject('-1');
                        });
                        return;
                    })];
            });
        });
    };
    /**
     * Validación de reglas
     *
     * *Rules validation*
     *
     * @param {any} rulesRq
     * @param {IProductsModel[]} products
     * @returns {Promise<IProductsModel[]}
     */
    ProductsService.prototype.validateRules = function (rulesRq, products) {
        var _this = this;
        var body = {
            rules: [
                rulesRq[0],
            ],
        };
        return new Promise(function (resolve, reject) {
            _this.requestService
                .validateRules({ data: body })
                .then(function (response) {
                response.data.rules_result.forEach(function (rule) {
                    products.forEach(function (product) {
                        if (product.visibility_rule === rule.rule_name) {
                            product.active = product.active && rule.result;
                        }
                    });
                });
                resolve(products);
                return;
            }, function () {
                reject();
            });
        });
    };
    /**
     * Guarda el log del dispositivo en la bitácora de la apliación
     *
     * *Saves device log in app bitacora*
     *
     * @param {LogDeviceModel} devicePrint
     */
    ProductsService.prototype.saveDataInBitacora = function (devicePrint) {
        this.requestService.saveDataInBitacora(devicePrint);
    };
    /**
     * Validación de reglas
     *
     * *Rules validation*
     *
     * @param {any} rulesRq
     * @param {IProductsModel[]} products
     * @returns {Promise<IProductsModel[]}
     */
    ProductsService.prototype.offersSelectAgreement = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService.offersSelectAgreement(body)
                            .then(function (res) {
                            resolve(res);
                        })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Validación de reglas
     *
     * *Rules validation*
     *
     * @param {any} rulesRq
     * @param {IProductsModel[]} products
     * @returns {Promise<IProductsModel[]}
     */
    ProductsService.prototype.AgreementDetail = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService.getAgreementsLoanDetail(id)
                            .then(function (res) {
                            resolve(res);
                        })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    ProductsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProductsService_Factory() { return new ProductsService(i0.ɵɵinject(i1.AbreCuentasService), i0.ɵɵinject(i2.RequestService), i0.ɵɵinject(i3.ChannelCommunicatorService)); }, token: ProductsService, providedIn: "root" });
    return ProductsService;
}());
export { ProductsService };
